/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createShoppingCartFromDiscriminatorValue, serializeShoppingCart, serializeUpdateVendorLineHeaderRequest, type ErrorResponse, type InternalErrorResponse, type ShoppingCart, type UpdateVendorLineHeaderRequest } from '../../../../../../models/index.js';
// @ts-ignore
import { DiscountRequestBuilderRequestsMetadata, type DiscountRequestBuilder } from './discount/index.js';
// @ts-ignore
import { RestoreRequestBuilderRequestsMetadata, type RestoreRequestBuilder } from './restore/index.js';
// @ts-ignore
import { SaveForLaterRequestBuilderRequestsMetadata, type SaveForLaterRequestBuilder } from './saveForLater/index.js';
// @ts-ignore
import { ShipWindowRequestBuilderRequestsMetadata, type ShipWindowRequestBuilder } from './shipWindow/index.js';
// @ts-ignore
import { SplitRequestBuilderRequestsMetadata, type SplitRequestBuilder } from './split/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/carts/{cart-id}/{shoppingCartId}/vendor-lines/{vendorCode}
 */
export interface WithVendorCodeItemRequestBuilder extends BaseRequestBuilder<WithVendorCodeItemRequestBuilder> {
    /**
     * The discount property
     */
    get discount(): DiscountRequestBuilder;
    /**
     * The restore property
     */
    get restore(): RestoreRequestBuilder;
    /**
     * The saveForLater property
     */
    get saveForLater(): SaveForLaterRequestBuilder;
    /**
     * The shipWindow property
     */
    get shipWindow(): ShipWindowRequestBuilder;
    /**
     * The split property
     */
    get split(): SplitRequestBuilder;
    /**
     * Removes the vendor's line and every item of the vendor from the cart, then re-evaluates the cart's promotions and tax. Removing a line that is already gone succeeds and returns the cart as it is. Agency organizations only.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ShoppingCart>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ShoppingCart | undefined>;
    /**
     * Replaces the header of one vendor's line on an agency cart: order type, PO number, terms, fulfillment method, note to the vendor and price level. A null or blank field clears it. Terms and price level must be ones the vendor offers (matched case-insensitively, stored in the vendor's spelling); a new price level reprices the line's items except rep-overridden ones. Agency organizations only.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ShoppingCart>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 409 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateVendorLineHeaderRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ShoppingCart | undefined>;
    /**
     * Removes the vendor's line and every item of the vendor from the cart, then re-evaluates the cart's promotions and tax. Removing a line that is already gone succeeds and returns the cart as it is. Agency organizations only.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Replaces the header of one vendor's line on an agency cart: order type, PO number, terms, fulfillment method, note to the vendor and price level. A null or blank field clears it. Terms and price level must be ones the vendor offers (matched case-insensitively, stored in the vendor's spelling); a new price level reprices the line's items except rep-overridden ones. Agency organizations only.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateVendorLineHeaderRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithVendorCodeItemRequestBuilderUriTemplate = "{+baseurl}/api/carts/{cart%2Did}/{shoppingCartId}/vendor-lines/{vendorCode}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithVendorCodeItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithVendorCodeItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    discount: {
        requestsMetadata: DiscountRequestBuilderRequestsMetadata,
    },
    restore: {
        requestsMetadata: RestoreRequestBuilderRequestsMetadata,
    },
    saveForLater: {
        requestsMetadata: SaveForLaterRequestBuilderRequestsMetadata,
    },
    shipWindow: {
        requestsMetadata: ShipWindowRequestBuilderRequestsMetadata,
    },
    split: {
        requestsMetadata: SplitRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithVendorCodeItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithVendorCodeItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createShoppingCartFromDiscriminatorValue,
    },
    put: {
        uriTemplate: WithVendorCodeItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createShoppingCartFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateVendorLineHeaderRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
